import React, { PureComponent, ReactNode } from 'react'
import './IndexSlider.scss'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IArticle } from '../StrapiService'
import { TFunction } from 'i18next'

interface Props {
  // imageUrls: string[]
  articles: IArticle[]
  t: TFunction
}

interface State {
  slideNumber: number
}

class IndexSlider extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {slideNumber: 2} as State
  }
  images = [
    '/index-slider-4.jpg',
    '/index-slider-1.jpg',
    '/index-slider-2.jpg',
    '/index-slider-3.jpg',
  ]
  slideDuration = 10000 // duration in ms

  oldOrNew(i: number) {
    if (this.state) {
      if (i === this.state.slideNumber-1 || (this.state.slideNumber === 1 && i === this.images.length)) return ' old'
      else if (i === this.state.slideNumber) return ' new'
    }
    return ''
  }

  get imagesElements() {
    return this.images.map((item, i) =>
      <img src={`${process.env.PUBLIC_URL}/assets/picts${item}`} className={`image-${i+1}${this.oldOrNew(i+1)}`} key={`slider-image-${i}`} />
    )
  }
  timer:NodeJS.Timer | undefined = undefined

  startSliderAnimation() {
    this.stopSliderAnimation()
    this.timer = setInterval(() => {
      if (this.state.slideNumber >= this.images.length) this.setState({slideNumber: 1})
      else this.setState({slideNumber: this.state.slideNumber+1})
    }, this.slideDuration)
  }

  stopSliderAnimation() {
    if (this.timer) clearInterval(this.timer)
  }

  componentDidMount() {
    this.startSliderAnimation()
  }

  render(): ReactNode {
    return (
      <div className="index-slider jumbotron" onMouseEnter={() => this.stopSliderAnimation()} onMouseLeave={() => this.startSliderAnimation()}>
        <div className="slider">
          {this.imagesElements}
        </div>
        <div className="content">
          <div className="representation flex-grow-1">
            <h1>{this.props.t("home.title1")} <br/>{this.props.t("home.title2")}</h1>
            <div className="buttons pb-1 mb-1">
              <Link className="btn btn-primary btn-block text-left mb-3" to="/permits">{this.props.t("home.link.orderPermit")}</Link>
              <Link className="btn btn-secondary btn-block text-left mb-3" to="/public-info">{this.props.t("home.link.publicInfo")}</Link>
            </div>
          </div>
          {
            this.props.articles.length > 0 &&
            <div className="articles">
              <h2>{this.props.t("home.announcements")}</h2>
              <ul>
                {
                  this.props.articles.map((a, i) => (
                    <li key={`article-${i}`}><Link to={`/article/${a.slug}`}>{a.title}</Link></li>
                  ))
                }
              </ul>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default IndexSlider
